export const PATH_MOTIVATION_TEST = '/motivation-test';
export const PATH_MOTIVATION_RESULT = '/motivation-test/details';
